/**
 * Per-connection SMTP settings.
 *
 * ApiService throws `{ detail }`, not the axios error. Callers that need the
 * server sentence should read `detail` as well as `error.response.data.detail`.
 */
import { ApiService } from '@/utils/api'

export interface ConnectionMailSettings {
  host: string
  port: number
  username: string
  from_addr: string
  use_tls: boolean
  password_set: boolean
  configured: boolean
}

export interface ConnectionMailSave {
  host: string
  port: number
  username: string
  from_addr: string
  use_tls: boolean
  password: string
}

function mailPath(connectionId: string): string {
  return `/connections/${encodeURIComponent(connectionId)}/mail`
}

export const connectionMailApi = {
  get: (connectionId: string): Promise<ConnectionMailSettings> =>
    ApiService.get<ConnectionMailSettings>(mailPath(connectionId)),

  save: (connectionId: string, body: ConnectionMailSave): Promise<ConnectionMailSettings> =>
    ApiService.put<ConnectionMailSettings>(mailPath(connectionId), body),

  remove: (connectionId: string): Promise<ConnectionMailSettings> =>
    ApiService.delete<ConnectionMailSettings>(mailPath(connectionId)),

  sendTest: (connectionId: string, body: { to: string }): Promise<{ sent: boolean }> =>
    ApiService.post<{ sent: boolean }>(`${mailPath(connectionId)}/test`, body),
}
